import Backbone from 'backbone';
import footerTemplate from './grid-footer.pug';

class FooterView extends Backbone.View {
  initialize({
    gridType,
    i18n,
  } = {}) {
    this.gridType = gridType;
    this.i18n = i18n;
  }

  render() {
    this.el.innerHTML = footerTemplate({
      gridType: this.gridType,
      i18n: this.i18n,
    });
  }
}

export default FooterView;
